import { AlertNotification, Button } from "@commonsku/styles";
import React, { useState } from "react";
import { Checkout } from "../../../interfaces/Checkout";
import CheckoutsErrorPopup from "../popups/CheckoutsErrorPopup/CheckoutsErrorPopup";

interface ImportedCheckoutsErrorBarProps {
  importedCheckouts: Checkout[];
  shop_id: string;
  order_id: string;
  shop_number: number;
  external_store_type: string;
}

const ImportedCheckoutsErrorBar = ({
  importedCheckouts,
  shop_id,
  order_id,
  shop_number,
  external_store_type,
}: ImportedCheckoutsErrorBarProps) => {
  const [shopPopup, setShopPopup] = useState<{
    type: string;
    props: any;
  } | null>(null);

  return (
    <>
      {shopPopup && shopPopup.type === "CheckoutsErrorPopup" && (
        <CheckoutsErrorPopup
          {...shopPopup.props}
          onClose={() => setShopPopup(null)}
        />
      )}
      <AlertNotification
        style={{
          marginBottom: 16,
        }}
        alertType="error"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ display: "block" }}>
              One or more of your checkouts contains a SKU that could not be
              resolved to a product or variant.
            </span>
            <span style={{ display: "block" }}>
              Repair these checkouts to export or convert.
            </span>
          </div>
          <Button
            size="small"
            style={{ height: "32px", width: "112px", alignSelf: "center" }}
            onClick={() => {
              setShopPopup({
                type: "CheckoutsErrorPopup",
                props: {
                  importedCheckouts,
                  shop_id,
                  order_id,
                  shop_number,
                  external_store_type,
                },
              });
            }}
          >
            Resolve Errors
          </Button>
        </div>
      </AlertNotification>
    </>
  );
};

export default ImportedCheckoutsErrorBar;
